<template>
    <common-modal width="small" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <h2 class="title" v-html="$t(`pages.referrals.show.cancellation.${type}.title`, { name: patientFullName })"></h2>
        </common-content-spacer>
        <common-buttons class="cancellation-buttons">
            <common-button
                v-if="withSecondOption"
                :label="$t(`pages.referrals.show.cancellation.${type}.buttons.no`)"
                type="secondary"
                @click="emitEvent({ name: 'deny' })"
            ></common-button>
            <common-button
                :label="$t(`pages.referrals.show.cancellation.${type}.buttons.yes`)"
                type="primary"
                @click="emitEvent({ name: 'confirm' })"
            ></common-button>
        </common-buttons>
    </common-modal>
</template>

<script>
    export default {
        props: {
            referral: { type: Object, required: true },
            type: { type: String, required: true },
            withSecondOption: { type: Boolean, required: false, default: true },
        },
        computed: {
            patientFullName() {
                return this.referral.patient.firstName + ' ' + this.referral.patient.lastName
            },
        },
    }
</script>

<style lang="scss" scoped>
    h2.title {
        text-align: center;
    }
    .cancellation-buttons {
        margin-top: 2rem;
    }
</style>
